import { useEffect, useRef, useState } from 'react'

const useOnScreen = ({ ref = undefined, rootMargin = '0px', multipleIntersections = false } = {}) => {
  // State and setter for storing whether element is visible
  const [isIntersecting, setIntersecting] = useState(false)
  const outerRef = useRef()

  useEffect(() => {
    const { current } = ref || outerRef
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Update our state when observer callback fires
        setIntersecting(entry.isIntersecting)

        // Unobserve after first intersection in screen
        if (!multipleIntersections && entry.isIntersecting && observer) {
          observer.unobserve(current)
        }
      },
      {
        rootMargin,
      }
    )

    if (current) {
      observer.observe(current)
    }

    return () => {
      if (current && observer) {
        observer.unobserve(current)
      }
    }
  }, [ref, rootMargin, multipleIntersections])

  return [isIntersecting, outerRef, multipleIntersections]
}

export default useOnScreen
